import React, { useEffect, useState, useMemo } from "react";
import Header from './includes/header';
import Footer from './includes/footer';
import { seo } from '../seo';
import * as Constants from "../config/constants";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from "react-i18next";
import { apiCall, dynamicMetaTags, manageNetworkError, valueCheck } from "../assets/js/common";
import icon from "../assets/images/icon.png";
import logo from "../assets/images/logo.png";

export default function Layout({
  children,
  pageName,
  seoData = null,
  pageUrl = null,
}) {
  const { t } = useTranslation(["translation", "errorMessage"]);
  const [settingInfo, setSettingInfo] = useState([]);
  const user = JSON.parse(localStorage.getItem(Constants.LOGIN_COOKIE_NAME));

  const getSettingInfo = async () => {
    const res = await apiCall('get', Constants.SETTING_URL, null, false);
    if (res?.status !== false && res?.data?.data?.recordInfo) {
      setSettingInfo(res.data.data.recordInfo);
    } else if (res?.status === false) {
      manageNetworkError(res);
    }
  };

  const updateTotalVisitor = async () => {
    const res = await apiCall('get', Constants.UPDATE_TOTAL_VISITOR_URL, null, false);
    if (res?.status !== false && res?.data?.status_code === 1) {
      const userData = user && user?.token ? user : {};
      if (res?.data?.data) {
        userData.hasVisited = res.data.data.hasVisited;
        localStorage.setItem(Constants.LOGIN_COOKIE_NAME, JSON.stringify(userData));
      }
    }
  };

  useEffect(() => {
    getSettingInfo();
  }, []);

  useEffect(() => {
    if (!user || !user.hasVisited || user.hasVisited !== Constants.SELECTION_YES) {
      updateTotalVisitor();
    }
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    const removeTagList = dynamicMetaTags.join(',');
    document.querySelectorAll(removeTagList).forEach(e => {
      if (!e.getAttribute('data-react-helmet')) e.remove();
    });
  }, []);

  /** ---------------------------------------------------
   * SEO MERGE LOGIC
   * Page SEO > Global Settings > Fallback
   * -------------------------------------------------- */
  const seoMeta = useMemo(() => {
    const siteTitle = valueCheck(settingInfo?.site_title);

    const title =
      valueCheck(seoData?.seo_title) ||
      (pageName ? `${pageName} | ${siteTitle}` : siteTitle);

    const description =
      valueCheck(seoData?.seo_description) ||
      valueCheck(settingInfo?.site_description);

    const keywords =
      valueCheck(seoData?.seo_keywords) ||
      valueCheck(settingInfo?.site_keywords);

    const canonical =
      valueCheck(seoData?.canonical_url) ||
      valueCheck(pageUrl) ||
      Constants.SITE_URL;

    return {
      title,
      description,
      keywords,
      canonical,
    };
  }, [seoData, settingInfo, pageName, pageUrl, t]);

  // Keep your existing seo() helper working
  useEffect(() => {
    seo({ title: seoMeta.title });
  }, [seoMeta.title]);

  return (
    <HelmetProvider>
      <Helmet>
    {/* Google Tag Manager */}
<script>
{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WDD4JQBC');`}
</script>
{/* End Google Tag Manager */}

        <title>{seoMeta.title}</title>

        <meta name="title" content={seoMeta.title} />
        <meta name="description" content={seoMeta.description} />
        <meta name="keywords" content={seoMeta.keywords} />

        <link rel="canonical" href={seoMeta.canonical} />

        {/* Open Graph */}
        <meta property="og:title" content={seoMeta.title} />
        <meta property="og:description" content={seoMeta.description} />
        <meta property="og:url" content={seoMeta.canonical} />
        <meta property="og:site_name" content={valueCheck(settingInfo?.site_title)} />
        <meta
          property="og:image"
          content={
            settingInfo?.website_og_icon
              ? Constants.BACKEND_FILE_URL + settingInfo.website_og_icon
              : icon
          }
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoMeta.title} />
        <meta name="twitter:description" content={seoMeta.description} />
        <meta
          name="twitter:image"
          content={
            settingInfo?.website_logo
              ? Constants.BACKEND_FILE_URL + settingInfo.website_logo
              : logo
          }
        />

        <link
          rel="icon"
          href={
            settingInfo?.website_fav_icon
              ? Constants.BACKEND_FILE_URL + settingInfo.website_fav_icon
              : icon
          }
        />
      </Helmet>

      <Header settingInfo={settingInfo} />
       {/* Google Tag Manager (noscript) */}
<noscript>
  <iframe
    src="https://www.googletagmanager.com/ns.html?id=GTM-WDD4JQBC"
    height="0"
    width="0"
    style={{ display: "none", visibility: "hidden" }}
    title="gtm"
  />
</noscript>
{/* End Google Tag Manager (noscript) */}
   
          
      <main>{children}</main>
      <Footer settingInfo={settingInfo} />
    </HelmetProvider>
  );
}

